import { d as r } from "./descriptors.js";
import { f as o } from "./fails.js";
import { f as t } from "./function-uncurry-this.js";
import { o as e } from "./object-get-prototype-of.js";
import { o as s } from "./object-keys.js";
import { t as i } from "./to-indexed-object.js";
import "./object-property-is-enumerable.js";
import { __exports as n } from "../../../_virtual/object-property-is-enumerable.js";
var a = t(n.f),
  p = t([].push),
  f = r && o(function () {
    var r = Object.create(null);
    return r[2] = 2, !a(r, 2);
  }),
  m = function m(o) {
    return function (t) {
      for (var n, m = i(t), u = s(m), j = f && null === e(m), c = u.length, l = 0, b = []; c > l;) n = u[l++], (!r || (j ? n in m : a(m, n))) && p(b, o ? [n, m[n]] : m[n]);
      return b;
    };
  },
  u = {
    entries: m(!0),
    values: m(!1)
  };
export { u as o };